import { render } from "./ContactEN.vue?vue&type=template&id=226eb4ae&scoped=true"
import script from "./ContactEN.vue?vue&type=script&lang=js"
export * from "./ContactEN.vue?vue&type=script&lang=js"

import "./ContactEN.vue?vue&type=style&index=0&id=226eb4ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-226eb4ae"

export default script